import React, { FC } from 'react';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { getAppImage } from 'helpers';
import { APP_IMAGES } from 'constants/index';

const styles = () =>
  createStyles({
    root: {
      height: 400,
      width: '100%',
    },
  });

interface IProps extends WithStyles<typeof styles> {}

const EmbedPlaceholder: FC<IProps> = ({ classes }) => (
  <img className={classes.root} {...getAppImage(APP_IMAGES.SocialLoading)} />
);

export default withStyles(styles)(EmbedPlaceholder);
